import { render, staticRenderFns } from "./MissedInjection.vue?vue&type=template&id=584a5460&"
import script from "./MissedInjection.vue?vue&type=script&lang=ts&"
export * from "./MissedInjection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports